(function ($, undefined) {
	'use strict';
	var utils;
	var lastInputTime = -1;
	var lastTimeoutId = -1;
    var lastSearch;

	var init = function () {
		utils = Fw.component.models().utils;

		$('.autocomplete__input').on('input focus', utils.debounce(onAutocompleteInput, 250));
		$('.autocomplete__input').on('blur', onAutocompleteBlur);
		$('.autocomplete__input').on('click', (e) => { e.stopPropagation(); });

		// DO NOT use click, mousedown is triggered before blur and that should be it
		$('.autocomplete__results').on('mousedown', 'li', onAutocompleteResultClick);
        
        $('.autocomplete__selections').on('click', '.autocomplete__item-remove', removeSelectedItem);
        
        // Auto rebuild and display the selected elements from the autocomplete value inputs
        $('.autocomplete-value.autoload').each(loadSelections);

		$(document).on('click', () => {
			if ($('.custom-offers-autocomplete').hasClass('autocomplete_show-results')) {
				$('.custom-offers-autocomplete').removeClass("autocomplete_show-results");
			}
		});
		deleteListElementListener();
	};

	function deleteListElementListener() {
		var dataList = $('.com-space-slider-admin__form_custom-list');
		dataList.each((i, el) => {
			var deleteCustomListSpaceBtn = $('.com-space-slider-delete-custom-btn');
			deleteCustomListSpaceBtn.on('click', (e) => {
				var id = $(e.currentTarget).attr('data-id');
				$(el).children(`li[data-id=${id}]`).remove();
			});
		});
	}

	function onAutocompleteInput(event) {
		var input = $(event.currentTarget);
		var value = input.val().trim();
		var ctn = input.closest('.autocomplete');
		var inputId = input.attr('data-autocomplete-id');
        var lastValue = input.attr('data-autocomplete-selection');
		var minLength = 2;

		const fetchData = (inputId, callback) => {
            if (value == lastSearch) {
                ctn.addClass('autocomplete_show-results');
            } else {
                lastSearch = value;
                setTimeout(checkInstantProcess, 250);

                if (inputId === 'com-events-webconf' || inputId === 'product') {
                    fetchWebconfs(value, callback);
                } else if (inputId.indexOf('event') !== -1) { //Included com-events and event-multi
                    fetchEvents(value, callback);
                } else if (inputId === 'com-blogs-custom') {
                    fetchBlogs(value, callback);
                }
			}
		};
        
        const checkInstantProcess = () => {
            if (!ctn.hasClass('autocomplete_show-results')) {
                ctn.addClass('autocomplete_processing');
            }
        };

		if (value.length >= minLength && value !== lastValue) {
			fetchData(inputId, (results) => {
				ctn.addClass('autocomplete_show-results');
				$('.autocomplete__results li:not(.autocomplete__empty)', ctn).remove();
                var html = '';
				if (results.length > 0) {
                    var listItems = [];
					switch (true) {
						case inputId.indexOf('webconf') !== -1:
							listItems = webconferencesToListItems(results);
							break;
						//case inputId.indexOf('com-events') !== -1:
						//case inputId.indexOf('event-multi') !== -1:
						case inputId.indexOf('event') !== -1:
							listItems = eventsToListItems(results, $('.autocomplete__selected-item', ctn));
							break;
						case inputId.indexOf('com-blogs-custom') !== -1:
							listItems = blogsToListItems(results);
							break;
						case inputId.indexOf('product') !== -1:
							listItems = webconferencesToListItems(results, $('.autocomplete__selected-item', ctn));
							break;
					}
                    html = listItems.join('');
				}
                if (html !== '') {
					$('.autocomplete__results', ctn).append(html);
                    ctn.find('.autocomplete__empty').removeClass('autocomplete__empty_visible');
                } else {
					ctn.find('.autocomplete__empty').addClass('autocomplete__empty_visible');
				}
				ctn.removeClass('autocomplete_processing');
			});
		} else {
			ctn.removeClass('autocomplete_show-results');
		}
	}

	function onAutocompleteBlur(e) {
		var input = $(e.currentTarget);
		var ctn = input.closest('.autocomplete');

		ctn.removeClass('autocomplete_show-results');
	}

	function onAutocompleteResultClick(e) {
		e.stopPropagation();
		var result = $(e.currentTarget);
		var ctn = result.closest('.autocomplete');
        var autoInput = $('.autocomplete__input', ctn);
		var input = $('.autocomplete-input', ctn);
		var inputId = input.attr('data-autocomplete-id') || autoInput.attr('data-autocomplete-id');
        var outputText = $('.autocomplete-output-text', ctn);

		if (result.hasClass('autocomplete__empty')) {
			return;
		}

		var name, id;
		if (inputId.indexOf('com-events') !== -1) {
			var eventList = ctn.find('.com-events__admin-form-list');
			name = result[0].title;
			id = result.attr("data-id");
			eventList.append($(`<li data-id="${id}" title="${name}">${name}<span class="com-events__admin-form-item" data-id="${id}">x</span></li>`));
            autoInput.attr('data-autocomplete-selection', name);
		} else if (inputId === 'event') {
			name = result[0].title;
			id = result.attr('data-id');
			input.val(name);
            autoInput.attr('data-autocomplete-selection', name);
			ctn.closest('form').find('input[data-autocomplete-value], input.autocomplete-value').val(id);
            outputText.text(name);
            result.remove();
		} else if (inputId === 'event-multi' || inputId === 'product') {
            name = result[0].title;
			id = result.attr('data-id');
            $('.autocomplete__selections', ctn).append(`<div class="autocomplete__selected-item p" data-id="${id}"><span>${name}</span><a class="autocomplete__item-remove"><i class="fa fa-times red"></i></a></div>`);
            var valueInput = ctn.find('input[data-autocomplete-value], input.autocomplete-value');
			valueInput.val(valueInput.val() === '' ? id : valueInput.val() + ',' + id);
            autoInput.val('');
            result.remove();
		} else if (inputId === 'com-blogs-custom') {
			name = result[0].title;
			var blog = result.attr("data-id");
			var blogList = ctn.find('.com-blogs-admin__custom-list');
			if ($('li[data-id=' + blog + "]", blogList).length === 0) {
				blogList.append($(`<li data-id="${blog}" title="${name}">${name}<span class="com-blogs-admin__delete-custom-btn" data-id="${blog}">x</span></li>`));
                autoInput.attr('data-autocomplete-selection', name);
			}
		}
		//console.log(result, ctn, input);
		input.trigger("change");
		input.trigger("autocomplete");
		ctn.removeClass('autocomplete_show-results');
		onAutocompleteBlur.apply(input, [{ currentTarget: input 	}]);
		deleteListElementListener();
	}
    
    function removeSelectedItem(e) {
        var item = $(e.currentTarget).closest('.autocomplete__selected-item');
        var id = item.attr('data-id');
        var valueInput = item.closest('form').find('input[data-autocomplete-value], input.autocomplete-value');
        var values = valueInput.val().split(',');
        item.remove();
        values.splice(values.indexOf(id), 1);
        valueInput.val(values.join(','));
    }

	function fetchEvents(value, callback = () => {}) {
		$.ajax({
			url: "/action/pmiAjaxGetEvent",
			method: "get",
			data: {
				"q": value,
                "showInvisible": true
			},
    		cache: false, 
			complete: function (response) {
				//console.log(response);
				var events = [];
				try {
					events = JSON.parse(response.responseText);
				} catch (ex) { }
				callback(events);
			}
		});
	}

	function fetchWebconfs(value, callback = () => {}) {
		$.ajax({
			url: "/action/ajaxGetProduct",
			method: "get",
			data: {
				"name": value
			},
    		cache: false, 
			complete: function (response) {
				var products = [];
				try {
					products = JSON.parse(response.responseText);
				} catch (ex) { }
				callback(products);
			}
		});
	}

	function fetchBlogs(value, callback = () => {}) {
		$.ajax({
			url: '/action/ajaxGetBlog',
			cache: false,
			type: 'GET',
			data: {
				"lang": document.documentElement.lang,
				"name": value,
				"ajax": true
			},
			success: function (response) {
				//console.log('get blogs: ', response);
				var blogs = [];
				try {
					blogs = JSON.parse(response);
				} catch (ex) { 
					blogs = response;
				}
				callback(blogs);
			}
		});
	}
 
	function eventsToListItems(events = [], elems) {
        let selections = [];
        if (elems) {
            elems.each((i, el) => {
                selections.push(el.getAttribute('data-id'));
            });
        }
        
		return events.map(event => {
			let name = decodeCMSEncoding(event.name);
            let date = !event.listDate ? '' : decodeCMSEncoding(event.listDate);
			let type = getEventAttendanceType(event.field4);
            let title = `#${event.id}`;
            
            if (date) {
                title += ` - ${date}`;
            }
            title += ` - ${name} (${type})`;
            if (selections.indexOf(event.id) === -1) {
                return `<li data-id="${event.id}" title="${title}">${title}</li>`;
            } else {
                return '';
            }
		});
	}

	function webconferencesToListItems(products = [], elems) {
        let selections = [];
        if (elems) {
            elems.each((i, el) => {
                selections.push(el.getAttribute('data-id'));
            });
        }
        
		return products.map(item => {
			let name = decodeCMSEncoding(item.name);
            let title = `#${item.productId} - ${name}`;
            
            if (selections.indexOf(item.productId) === -1) {
                return `<li data-id="${item.productId}" title="${title}">${title}</li>`;
            } else {
                return '';
            }
		});
	}

	function blogsToListItems(blogs = []) {
		return blogs.map(blog => {
			var title = decodeCMSEncoding(blog.name);
			return `<li data-id="${blog.id}" title="#${blog.id} - ${title}">#${blog.id} - ${title}</li>`;
		});
	}

	function fuzzyMatch(pattern, str) {
		pattern = utils.removeLowercaseDiacritics(pattern.toLowerCase());
		str = utils.removeLowercaseDiacritics(str.toLowerCase());
		pattern = '.{0,3}' + pattern.split('').join('.{0,3}') + '.{0,3}';
		const re = new RegExp(pattern, 'i');
		return re.test(str);
	}
    
    function getEventAttendanceType(key) {
        const fr = document.documentElement.lang === 'fr';
        return key === 'webcast' ? (fr ? 'Webdiffusion' : 'Webcast') : (fr ? 'En personne' : 'In person');
    }
    
    function loadSelections(i, el) {
        if (!el.value || el.value === '0' || el.value === '-1') {
            return false;
        }
        
        const ctn = $(el).closest('.autocomplete');
        const outputCtn = ctn.find('.autocomplete__selections');
        const autoInput = ctn.find('.autocomplete__input');
        const type = autoInput.attr('data-autocomplete-id');
        
        switch (type) {
            case 'event-multi':
                $.ajax({
                    url: "/action/pmiAjaxGetEvent",
                    method: "get",
                    data: {
                        "ids": el.value
                    },
                    cache: false,
                    complete: function(response) {
                        const events = JSON.parse(response.responseText);
                        outputCtn.html('');
                        events.map(event => {
                            let id = event.id;
                            let name = decodeCMSEncoding(event.name);
                            let date = !event.listDate ? '' : decodeCMSEncoding(event.listDate);
                            let type = getEventAttendanceType(event.field4);
                            let title = `#${event.id}`;

                            if (date) {
                                title += ` - ${date}`;
                            }
                            title += ` - ${name} (${type})`;
                            outputCtn.append(`<div class="autocomplete__selected-item p" data-id="${id}"><span>${title}</span><a class="autocomplete__item-remove"><i class="fa fa-times red"></i></a></div>`);
                        });
                    }
                });
                break;
            case 'product':
                $.ajax({
                    url: "/action/ajaxGetProduct",
                    method: "get",
                    data: {
                        'ids': el.value
                    },
                    cache: false, 
                    complete: function (response) {
                        const products = JSON.parse(response.responseText);
                        outputCtn.html('');
                        products.map(item => {
                            let id = item.id;
                            let name = decodeCMSEncoding(item.name);
                            let title = `#${id} - ${name}`;
                            
                            outputCtn.append(`<div class="autocomplete__selected-item p" data-id="${id}"><span>${title}</span><a class="autocomplete__item-remove"><i class="fa fa-times red"></i></a></div>`);
                        });
                    }
                });
                break;
        }
    }

	$(window).ready(init);
    
})(jQuery);
